import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlterarKmComponent } from './pages/alterar-km/alterar-km.component';
import { AlterarKmController } from './controllers';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@app/shared/animations/animations.module';
import { ComponentsModule } from '@app/shared/components/components.module';
import { EditarKmComponent } from './components/editar-km/editar-km.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AlterarKmComponent,
    EditarKmComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), AlterarKmController],
})
export class AlterarKmModule { }
